// Native product pages share the configurator's cart metadata and artwork database.
(function () {
  'use strict';
  if (window.VPProductCart) return;
  var CART_KEY = 'vp_cart';
  var CHECKOUT_KEY = 'vp_checkout_pending';
  var DB_NAME = 'vinylpac_artwork';
  var STORE_NAME = 'artworks';
  var TIMEOUT = 15000;
  var MAX_CART = 200;
  var MAX_METADATA = 2 * 1024 * 1024;
  var MAX_FILE = 20 * 1024 * 1024; // decoded bytes, checkout Worker LIMITS.fileBytes
  var PREVIEW_MAX = 48 * 1024 * 1024; // data-URL length of a preview whose original uploads instead (the old cap)
  var OVERSIZE_MESSAGE = "This file is over 20 MB. Add to cart now and email it to info@vinylpac.us after checkout with your order number.";
  var fields = ['artworkUrl', 'artworkOriginalUrl', 'lidArtworkUrl', 'lidArtworkOriginalUrl', 'ringArtworkUrl', 'ringArtworkOriginalUrl'];
  var originals = new Map();
  var originalArtwork = new Map();
  var lastId = 0;
  var saving = false;
  // Josh 10/17: every file type is accepted, kept with the type it was uploaded as.
  var DATA_URL = /^data:[a-z0-9][a-z0-9!#$&^_.+-]*\/[a-z0-9][a-z0-9!#$&^_.+-]*;base64,[a-z0-9+/]+={0,2}$/i;
  // A name the browser can't show as it is (PDF, AI, PSD…) means the item also carries the customer's original.
  function needsOriginal(name) {
    var ext = /\.([a-z0-9]{1,10})$/i.exec(String(name || '').trim());
    return !!ext && !/^(png|jpe?g|webp|gif|svg)$/i.test(ext[1]);
  }

  function error(message) { return new Error(message + ' Your original cart is unchanged.'); }
  function validId(id) { return Number.isSafeInteger(id) && id > 0; }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function canonical(value) {
    if (Array.isArray(value)) return value.map(canonical);
    if (value && typeof value === 'object') {
      var result = {};
      Object.keys(value).sort().forEach(function (key) { result[key] = canonical(value[key]); });
      return result;
    }
    return value;
  }
  function identity(item) { return JSON.stringify(canonical(item)); }

  function load() {
    var raw;
    try { raw = sessionStorage.getItem(CART_KEY); }
    catch (e) { throw error('Browser cart storage is unavailable.'); }
    var items;
    try {
      if (raw && raw.length > MAX_METADATA) throw new Error();
      items = JSON.parse(raw || '[]');
      if (!Array.isArray(items) || items.length > MAX_CART) throw new Error();
      var ids = new Set();
      items.forEach(function (item) {
        if (!item || !validId(item.id) || ids.has(item.id)) throw new Error();
        ids.add(item.id);
      });
    } catch (e) { throw error('The saved cart could not be read. Keep this tab open and contact the shop.'); }
    return items;
  }

  function read() {
    var items = load();
    items.forEach(function (item) {
      // A later drawer refresh must not silently authorize replacing a changed item.
      if (!originals.has(item.id)) originals.set(item.id, identity(item));
    });
    return items;
  }

  function open() {
    return new Promise(function (resolve, reject) {
      var request;
      var finished = false;
      var timer = setTimeout(function () { fail('Artwork storage did not respond in time.'); }, TIMEOUT);
      function fail(message) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        reject(error(message));
      }
      try {
        if (!window.indexedDB) throw new Error();
        request = window.indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = function () {
          if (finished) { request.transaction.abort(); return; }
          if (!request.result.objectStoreNames.contains(STORE_NAME)) request.result.createObjectStore(STORE_NAME, { keyPath: 'itemId' });
        };
        request.onblocked = function () { fail('Artwork storage is blocked. Close other VINYLPAC tabs and try again.'); };
        request.onerror = function () { fail('Artwork storage is unavailable.'); };
        request.onsuccess = function () {
          var db = request.result;
          if (finished) { db.close(); return; }
          if (!db.objectStoreNames.contains(STORE_NAME)) { db.close(); fail('The artwork store is missing.'); return; }
          finished = true;
          clearTimeout(timer);
          db.onversionchange = function () { db.close(); };
          resolve(db);
        };
      } catch (e) { fail('Artwork storage is unavailable.'); }
    });
  }

  function transaction(db, mode, action) {
    return new Promise(function (resolve, reject) {
      var tx;
      var result;
      var finished = false;
      var failure;
      var timer = setTimeout(function () {
        failure = error('Artwork storage did not respond in time.');
        if (tx) { try { tx.abort(); } catch (e) {} }
        finish(failure);
      }, TIMEOUT);
      function finish(err) {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        if (err) reject(err); else resolve(result);
      }
      try {
        tx = db.transaction(STORE_NAME, mode);
        var store = tx.objectStore(STORE_NAME);
        if (store.keyPath !== 'itemId') throw error('The artwork store format is unavailable.');
        tx.oncomplete = function () { finish(); };
        tx.onabort = tx.onerror = function () {
          var problem = failure || error('Artwork storage is full or unavailable.');
          if (tx.error && tx.error.name === 'ConstraintError') problem.name = 'ConstraintError';
          finish(problem);
        };
        action(store, function (value) { result = value; }, function (err) {
          failure = err;
          try { tx.abort(); } catch (e) {}
          finish(err);
        });
      } catch (e) {
        if (tx) { try { tx.abort(); } catch (ignored) {} }
        finish(e);
      }
    });
  }

  function getArtwork(id) {
    return Promise.resolve().then(function () {
      if (!validId(id)) throw error('The cart item ID is invalid.');
      return open();
    }).then(function (db) {
      return transaction(db, 'readonly', function (store, done) {
        var request = store.get(id);
        request.onsuccess = function () {
          var record = request.result || null;
          if (!originalArtwork.has(id)) originalArtwork.set(id, record ? Object.assign({}, record) : null);
          done(record);
        };
      }).finally(function () { db.close(); });
    });
  }

  function metadata(item) {
    var config = item && item.configuration;
    if (!config || config.version !== 1 || ['jars', 'jar-labels'].indexOf(config.kind) === -1 || item.cat !== config.kind) {
      throw error('The product configuration is invalid.');
    }
    if (typeof config.productId !== 'string' || !config.productId || config.productId.length > 200) throw error('Choose a product before saving.');
    if (!Number.isSafeInteger(item.qty) || item.qty < 1 || item.qty > 1000000 || item.qty !== config.qty) throw error('The saved quantity is invalid.');
    var unit = Number(item.unitPrice);
    var total = Number(item.total);
    if (!isFinite(unit) || !isFinite(total) || unit <= 0 || total <= 0 || total > 1000000000 || Math.round(unit * item.qty * 100) !== Math.round(total * 100)) {
      throw error('The displayed price and cart total do not match.');
    }
    if (typeof item.name !== 'string' || !item.name || item.name.length > 300 || !Array.isArray(item.properties) || item.properties.length > 100) throw error('The product details are incomplete.');
    item.properties.forEach(function (p) {
      if (!p || typeof p.name !== 'string' || typeof p.value !== 'string' || p.name.length > 200 || p.value.length > 10000) throw error('The product options are invalid.');
    });
    var configRaw = JSON.stringify(config);
    if (configRaw.length > 50000 || /"(?:data:|blob:)/i.test(configRaw)) throw error('The saved options are too large or contain full artwork.');
    if (config.kind === 'jar-labels') {
      // Live Shopify variant IDs, or a preview-only finish (Chrome/Gold) that has no live variant yet.
      var labelVariant = /^(?:\d+|preview-(?:chrome|gold)-\d+)$/;
      if (!labelVariant.test(String(config.variantId || '')) || !config.tier || !config.finish || !config.emboss) throw error('Choose the label print options before saving.');
      if (config.lidWrap && (!labelVariant.test(String(config.lidWrap.variantId || '')) || !Number.isSafeInteger(config.lidWrap.priceCents) || config.lidWrap.priceCents < 0)) throw error('The lid wrap option is invalid.');
    }
    var result = {
      id: 0, name: item.name, qty: item.qty, unitPrice: item.unitPrice, total: total.toFixed(2),
      properties: clone(item.properties), cat: item.cat, configuration: clone(config),
      artworkFile: item.artworkFile || (config.kind === 'jars' ? '(none)' : config.bodyFilename || ''),
      artworkThumb: item.artworkThumb || '', thumbUrl: item.thumbUrl || ''
    };
    if (item.liveStoreUrl) result.liveStoreUrl = String(item.liveStoreUrl);
    if (typeof result.artworkThumb !== 'string' || result.artworkThumb.length > 150000 || typeof result.thumbUrl !== 'string' || result.thumbUrl.length > 4000 || /^data:|^blob:/i.test(result.thumbUrl)) throw error('The cart preview is too large.');
    return result;
  }

  // Only the file that uploads counts against the 20 MB cap: the original when there is one, else the picture itself.
  // A preview drawn from a PDF/AI can be far bigger than its original and never uploads (Astra 10/17 round 2).
  function checkArtworkSize(value, field, record) {
    var original = field.replace(/Url$/, 'OriginalUrl');
    if (!/OriginalUrl$/.test(field) && record && record[original]) {
      if (value.length > PREVIEW_MAX) throw error('A preview image is too large.');
      return;
    }
    var encoded = value.length - value.indexOf(',') - 1;
    var padding = value.endsWith('==') ? 2 : value.endsWith('=') ? 1 : 0;
    if (encoded / 4 * 3 - padding > MAX_FILE) throw new Error(OVERSIZE_MESSAGE);
  }

  function artwork(item, record) {
    var config = item.configuration;
    var expected = config.artwork || {};
    var result = {};
    var length = 0;
    fields.forEach(function (field) {
      var value = record && record[field] || null;
      if (value) {
        if (typeof value !== 'string' || !DATA_URL.test(value)) throw error('A full artwork file is invalid.');
        checkArtworkSize(value, field, record);
        var encoded = value.slice(value.indexOf(',') + 1);
        try { atob(encoded); } catch (e) { throw error('A full artwork file could not be read.'); }
        length += value.length;
      }
      result[field] = value;
    });
    if (length > 192 * 1024 * 1024) throw error('The combined artwork is too large for this cart item.');
    if (config.kind === 'jars') return result;
    [['body', 'artworkUrl', 'artworkOriginalUrl'], ['lid', 'lidArtworkUrl', 'lidArtworkOriginalUrl'], ['ring', 'ringArtworkUrl', 'ringArtworkOriginalUrl']].forEach(function (part) {
      var role = part[0];
      // Jar labels (Josh 10/15): artwork is optional, so only files the line says it carries are required.
      var required = config.kind === 'jar-labels' ? !!expected[role] : role !== 'ring' || !!config.lidWrap || !!expected.ring;
      if (required && !result[part[1]]) throw error('Upload the full ' + role + ' artwork before saving.');
      if ((expected[role + 'Original'] || needsOriginal(config[role + 'Filename'])) && !result[part[2]]) throw error('The original ' + role + ' file is missing.');
    });
    return result;
  }

  function nextId(items) {
    var random = new Uint32Array(1);
    if (!window.crypto || !window.crypto.getRandomValues) throw error('Secure cart IDs are unavailable in this browser.');
    window.crypto.getRandomValues(random);
    var id = Math.max(Date.now() * 1024 + (random[0] % 1024), lastId + 1);
    while (items.some(function (item) { return item.id === id; })) id++;
    if (!validId(id)) throw error('A new cart item ID could not be created.');
    lastId = id;
    return id;
  }

  function publish(items) {
    var next = JSON.stringify(items);
    if (next.length > MAX_METADATA) throw error('The cart is full. Remove an item before adding another.');
    var previous = sessionStorage.getItem(CART_KEY);
    var pending = sessionStorage.getItem(CHECKOUT_KEY);
    var saved;
    try { saved = JSON.parse(pending || 'null'); } catch (e) {}
    // Keep uncertain or unreadable checkout markers: only a known ready link may expire.
    var invalidate = previous !== next && saved && saved.status === 'ready';
    try {
      if (invalidate) {
        sessionStorage.removeItem(CHECKOUT_KEY);
        if (sessionStorage.getItem(CHECKOUT_KEY) !== null) throw new Error();
      }
      sessionStorage.setItem(CART_KEY, next);
      if (sessionStorage.getItem(CART_KEY) !== next) throw new Error();
    } catch (e) {
      var rollbackFailed = false;
      try {
        if (sessionStorage.getItem(CART_KEY) !== previous) {
          if (previous === null) sessionStorage.removeItem(CART_KEY); else sessionStorage.setItem(CART_KEY, previous);
        }
        if (invalidate && sessionStorage.getItem(CHECKOUT_KEY) !== pending) sessionStorage.setItem(CHECKOUT_KEY, pending);
      } catch (ignored) { rollbackFailed = true; }
      if (rollbackFailed) throw new Error('Browser storage failed during rollback. Keep this tab open and contact the shop before checkout; your original artwork is preserved.');
      throw error('Browser cart storage is full or unavailable.');
    }
  }

  async function commit(item, artworkRecordOrNull, editIdOrNull) {
    if (saving) throw error('A cart item is already saving. Please wait.');
    saving = true;
    var db;
    var newId;
    var durable = false;
    var committed = false;
    try {
      var saved = metadata(item);
      var record = artwork(saved, artworkRecordOrNull);
      var editId = editIdOrNull == null ? null : editIdOrNull;
      if (typeof editId === 'string' && /^\d+$/.test(editId)) editId = Number(editId);
      if (editId !== null && (!validId(editId) || !originals.has(editId))) throw error('Load the original cart item before editing it.');
      function current() {
        var items = load();
        if (editId !== null) {
          var original = items.find(function (entry) { return entry.id === editId; });
          if (!original || identity(original) !== originals.get(editId)) throw error('The original item changed or was removed. Reload it before editing.');
          var kind = original.configuration && original.configuration.kind || original.cat;
          if (kind !== saved.cat) throw error('This edit belongs to a different product type.');
        } else if (items.length >= MAX_CART) throw error('The cart is full. Remove an item before adding another.');
        return items;
      }
      var items = current();
      if (saved.cat === 'jars') {
        await Promise.resolve();
        items = current();
        saved.id = nextId(items);
        if (editId === null) items.push(saved);
        else items.splice(items.findIndex(function (entry) { return entry.id === editId; }), 1, saved);
        publish(items);
        committed = true;
        originals.set(saved.id, identity(saved));
        return clone(saved);
      }
      db = await open();
      for (var attempt = 0; attempt < 5; attempt++) {
        newId = nextId(items);
        record.itemId = newId;
        try {
          // add, never put: collisions cannot overwrite another tab's original artwork.
          await transaction(db, 'readwrite', function (store, done, fail) {
            if (editId === null || !originalArtwork.has(editId)) { store.add(record); return; }
            var request = store.get(editId);
            request.onsuccess = function () {
              var before = originalArtwork.get(editId);
              var currentRecord = request.result || null;
              if (!!before !== !!currentRecord || fields.some(function (field) { return (before && before[field] || null) !== (currentRecord && currentRecord[field] || null); })) {
                fail(error('The original artwork changed. Reload the cart item before editing.'));
                return;
              }
              try { store.add(record); } catch (e) { fail(error('Artwork storage is full or unavailable.')); }
            };
          });
          durable = true;
          break;
        } catch (e) {
          if (e.name !== 'ConstraintError' || attempt === 4) throw e;
        }
      }
      items = current();
      saved.id = newId;
      if (editId === null) items.push(saved);
      else items.splice(items.findIndex(function (entry) { return entry.id === editId; }), 1, saved);
      publish(items);
      committed = true;
      originals.set(newId, identity(saved));
      try { if (window.VPArtUpload) window.VPArtUpload.added(newId, record, saved.configuration); } catch (e) {}  // theme: art up now (vp-art.js)
      // Old records may still belong to another tab or an uncertain checkout.
      return clone(saved);
    } catch (e) {
      if (durable && !committed && db && !loadContains(newId)) {
        try { await transaction(db, 'readwrite', function (store) { store.delete(newId); }); } catch (ignored) {}
      }
      throw e instanceof Error ? e : error('The cart item could not be saved.');
    } finally {
      if (db) db.close();
      saving = false;
    }
  }

  function loadContains(id) {
    try { return load().some(function (item) { return item.id === id; }); }
    catch (e) { return true; }
  }

  // ── Bulk Order Form (Josh 10/17): many builder sticker lines saved in one step ──
  // The lines are ordinary builder items (configuration v1, no `kind`), exactly as addToCart() saves them, so the
  // configurator's drawer, edit and checkout treat them like any other. One call replaces the form's earlier lines
  // (same `bulkForm` session id) and adds the new ones: all of them or none.
  var BULK_CHIPS = { 'die-cut': 'Die Cut Stickers', 'transfer': 'Kiss Cut Transfer Stickers', 'kiss-cut': 'Kisscut Stickers' };

  function builderMetadata(item) {
    var config = item && item.configuration;
    if (!config || config.version !== 1 || config.kind || config.cat !== 'custom-stickers' || item.cat !== 'custom-stickers' ||
        BULK_CHIPS[config.chipId] !== config.productName || item.name !== config.productName ||
        typeof config.bulkForm !== 'string' || !config.bulkForm) {
      throw error('The design options are invalid.');
    }
    if (!Number.isSafeInteger(item.qty) || item.qty < 1 || item.qty > 1000000 || item.qty !== config.qty) throw error('The saved quantity is invalid.');
    var unit = Number(item.unitPrice);
    var total = Number(item.total);
    if (!isFinite(unit) || !isFinite(total) || unit <= 0 || total <= 0 || total > 1000000000 || Math.round(unit * 100) * item.qty !== Math.round(total * 100)) {
      throw error('The displayed price and cart total do not match.');
    }
    if (!Array.isArray(item.properties) || item.properties.length > 100) throw error('The product details are incomplete.');
    item.properties.forEach(function (p) {
      if (!p || typeof p.name !== 'string' || typeof p.value !== 'string' || p.name.length > 200 || p.value.length > 10000) throw error('The product options are invalid.');
    });
    var configRaw = JSON.stringify(config);
    if (configRaw.length > 50000 || /"(?:data:|blob:)/i.test(configRaw)) throw error('The saved options are too large or contain full artwork.');
    var result = {
      id: 0, name: item.name, qty: item.qty, unitPrice: item.unitPrice, total: total.toFixed(2),
      properties: clone(item.properties), cat: item.cat, configuration: clone(config),
      artworkFile: item.artworkFile || '(none)', artworkThumb: item.artworkThumb || '', thumbUrl: item.thumbUrl || ''
    };
    if (typeof result.artworkThumb !== 'string' || result.artworkThumb.length > 150000 || typeof result.thumbUrl !== 'string' || result.thumbUrl.length > 4000 || /^data:|^blob:/i.test(result.thumbUrl)) throw error('The cart preview is too large.');
    return result;
  }

  function builderArtwork(saved, record) {
    var expected = saved.configuration.artwork || {};
    var named = saved.artworkFile && saved.artworkFile !== '(none)';
    if (!record) {
      if (named || expected.body || expected.bodyOriginal || saved.artworkThumb) throw error('A design is missing its artwork file.');
      return null;
    }
    var result = {};
    var length = 0;
    fields.forEach(function (field) {
      var value = record[field] || null;
      if (value) {
        if (typeof value !== 'string' || !DATA_URL.test(value)) throw error('An artwork file is invalid.');
        checkArtworkSize(value, field, record);
        length += value.length;
      }
      result[field] = value;
    });
    if (length > 192 * 1024 * 1024) throw error('A design’s artwork is too large.');
    // restoreCartArtwork() rules: a named file needs the full image; a PDF, AI, PSD… also needs its original.
    if ((named || expected.body) && !result.artworkUrl) throw error('A design is missing its full artwork.');
    if ((expected.bodyOriginal || needsOriginal(saved.configuration.bodyFilename)) && !result.artworkOriginalUrl) throw error('A design is missing its original file.');
    return result;
  }

  // built = [{ item, artwork }], sessionId = the form's bulkForm id, ref = the order ref to keep when the cart was empty.
  async function commitBuilderItems(built, sessionId, ref) {
    if (saving) throw error('The cart is already saving. Please wait.');
    if (!Array.isArray(built) || !built.length) throw error('Add at least one design.');
    if (typeof sessionId !== 'string' || !sessionId) throw error('The order form session is missing.');
    saving = true;
    var db;
    var newIds = [];
    var committed = false;
    try {
      var lines = built.map(function (b) {
        var saved = builderMetadata(b.item);
        if (saved.configuration.bulkForm !== sessionId) throw error('A design belongs to another order form.');
        return { saved: saved, record: builderArtwork(saved, b.artwork) };
      });
      var before = load();
      var replaced = before.filter(function (it) { return it.configuration && it.configuration.bulkForm === sessionId; });
      var kept = before.filter(function (it) { return !(it.configuration && it.configuration.bulkForm === sessionId); });
      // Unchanged designs (Back from Shopify, then Check out on the form again): the saved lines stay exactly as they
      // are, so the cart's checkout key is the same and its saved Shopify checkout resumes. Never a second draft.
      if (replaced.length === lines.length) {
        var same = lines.every(function (line, i) {
          var a = clone(line.saved);
          a.id = replaced[i].id;
          return identity(a) === identity(replaced[i]);
        });
        for (var k = 0; same && k < lines.length; k++) {
          var stored = await getArtwork(replaced[k].id);
          var want = lines[k].record;
          same = !!stored === !!want && (!want || fields.every(function (f) { return (stored[f] || null) === (want[f] || null); }));
        }
        if (same && identity(load()) === identity(before)) return replaced.map(clone);
      }
      if (kept.length + lines.length > MAX_CART) throw error('The cart is full. Remove some items first.');
      var items = kept.slice();
      lines.forEach(function (line) {
        line.saved.id = nextId(items.concat(lines.filter(function (l) { return l.saved.id; }).map(function (l) { return l.saved; })));
        if (line.record) line.record.itemId = line.saved.id;
      });
      var records = lines.filter(function (line) { return line.record; }).map(function (line) { return line.record; });
      if (records.length) {
        db = await open();
        // One transaction: every design's artwork lands, or none does. add, never put (another tab's ids).
        await transaction(db, 'readwrite', function (store) {
          records.forEach(function (record) { store.add(record); });
        });
        newIds = records.map(function (r) { return r.itemId; });
      }
      // Nothing else may have touched the cart while the artwork was written.
      if (identity(load()) !== identity(before)) throw error('The cart changed in another tab. Try again.');
      lines.forEach(function (line) { items.push(line.saved); });
      publish(items);
      committed = true;
      if (!kept.length && ref) {
        try { sessionStorage.setItem('vp_order_ref', String(ref)); } catch (e) {}
      }
      lines.forEach(function (line) { originals.set(line.saved.id, identity(line.saved)); });
      lines.forEach(function (line) { try { if (window.VPArtUpload) window.VPArtUpload.added(line.saved.id, line.record, line.saved.configuration); } catch (e) {} });  // theme: art up now (vp-art.js)
      // The form's earlier lines' artwork stays in the database: another tab (a duplicated tab shares it) or an
      // uncertain checkout may still need it, as commit() leaves old records too.
      return lines.map(function (line) { return clone(line.saved); });
    } catch (e) {
      if (newIds.length && !committed && db) {
        try { await transaction(db, 'readwrite', function (store) { newIds.forEach(function (id) { if (!loadContains(id)) store.delete(id); }); }); } catch (ignored) {}
      }
      throw e instanceof Error ? e : error('The designs could not be saved.');
    } finally {
      if (db) db.close();
      saving = false;
    }
  }

  // ── Reorder (Josh 10/25): a past order's builder lines, rebuilt by reorder.js, saved in one step ──
  // Like the Bulk Order Form: ordinary builder items (configuration v1, no `kind`), all of them or none. One call
  // replaces the lines an earlier tap saved for the SAME past-order lines (configuration.reorderOf + reorderLine, the
  // line's position on that order) and adds the new ones, so a refresh, a retry or a double tap never doubles a
  // design, while "Reorder this" on two designs of one order keeps both; everything else in the cart stays.
  var REORDER_OF = /^#\d{3,8}$/;

  function reorderMetadata(item, from) {
    var config = item && item.configuration;
    if (!config || config.version !== 1 || config.kind || typeof config.cat !== 'string' || !config.cat || item.cat !== config.cat ||
        typeof config.productName !== 'string' || !config.productName || item.name !== config.productName ||
        config.reorderOf !== from || !Number.isSafeInteger(config.reorderLine) || config.reorderLine < 1 || config.reorderLine > 1000) {
      throw error('The design options are invalid.');
    }
    if (!Number.isSafeInteger(item.qty) || item.qty < 1 || item.qty > 1000000 || item.qty !== config.qty) throw error('The saved quantity is invalid.');
    var unit = Number(item.unitPrice);
    var total = Number(item.total);
    if (!isFinite(unit) || !isFinite(total) || unit <= 0 || total <= 0 || total > 1000000000 || Math.round(unit * 100) * item.qty !== Math.round(total * 100)) {
      throw error('The displayed price and cart total do not match.');
    }
    if (!Array.isArray(item.properties) || item.properties.length > 100) throw error('The product details are incomplete.');
    item.properties.forEach(function (p) {
      if (!p || typeof p.name !== 'string' || typeof p.value !== 'string' || p.name.length > 200 || p.value.length > 10000) throw error('The product options are invalid.');
    });
    var configRaw = JSON.stringify(config);
    if (configRaw.length > 50000 || /"(?:data:|blob:)/i.test(configRaw)) throw error('The saved options are too large or contain full artwork.');
    var result = {
      id: 0, name: item.name, qty: item.qty, unitPrice: item.unitPrice, total: total.toFixed(2),
      properties: clone(item.properties), cat: item.cat, configuration: clone(config),
      artworkFile: item.artworkFile || '(none)', artworkThumb: item.artworkThumb || '', thumbUrl: item.thumbUrl || ''
    };
    if (typeof result.artworkThumb !== 'string' || result.artworkThumb.length > 150000 || typeof result.thumbUrl !== 'string' || result.thumbUrl.length > 4000 || /^data:|^blob:/i.test(result.thumbUrl)) throw error('The cart preview is too large.');
    return result;
  }

  // built = [{ item, artwork }], from = the past order's name ("#4199"), every item's configuration.reorderOf.
  async function commitReorderItems(built, from) {
    if (saving) throw error('The cart is already saving. Please wait.');
    if (!Array.isArray(built) || !built.length) throw error('Nothing to reorder.');
    if (typeof from !== 'string' || !REORDER_OF.test(from)) throw error('The past order is missing.');
    saving = true;
    var db;
    var newIds = [];
    var committed = false;
    try {
      var lines = built.map(function (b) {
        var saved = reorderMetadata(b.item, from);
        return { saved: saved, record: builderArtwork(saved, b.artwork) };
      });
      var keys = {};
      lines.forEach(function (line) {
        var k = String(line.saved.configuration.reorderLine);
        if (keys[k]) throw error('A design is listed twice.');
        keys[k] = true;
      });
      var before = load();
      var kept = before.filter(function (it) {
        var c = it.configuration;
        return !(c && c.reorderOf === from && keys[String(c.reorderLine)]);
      });
      if (kept.length + lines.length > MAX_CART) throw error('The cart is full. Remove some items first.');
      var items = kept.slice();
      lines.forEach(function (line) {
        line.saved.id = nextId(items.concat(lines.filter(function (l) { return l.saved.id; }).map(function (l) { return l.saved; })));
        if (line.record) line.record.itemId = line.saved.id;
      });
      var records = lines.filter(function (line) { return line.record; }).map(function (line) { return line.record; });
      if (records.length) {
        db = await open();
        // One transaction: every design's artwork lands, or none does. add, never put (another tab's ids).
        await transaction(db, 'readwrite', function (store) {
          records.forEach(function (record) { store.add(record); });
        });
        newIds = records.map(function (r) { return r.itemId; });
      }
      // Nothing else may have touched the cart while the artwork was written.
      if (identity(load()) !== identity(before)) throw error('The cart changed in another tab. Try again.');
      lines.forEach(function (line) { items.push(line.saved); });
      publish(items);
      committed = true;
      lines.forEach(function (line) {
        originals.set(line.saved.id, identity(line.saved));
        // On the theme the artwork goes up to Shopify Files now (vp-art.js), as every other save does.
        try { if (window.VPArtUpload) window.VPArtUpload.added(line.saved.id, line.record, line.saved.configuration); } catch (e) {}
      });
      // Replaced lines' artwork stays in the database, as commitBuilderItems leaves old records too.
      return lines.map(function (line) { return clone(line.saved); });
    } catch (e) {
      if (newIds.length && !committed && db) {
        try { await transaction(db, 'readwrite', function (store) { newIds.forEach(function (id) { if (!loadContains(id)) store.delete(id); }); }); } catch (ignored) {}
      }
      throw e instanceof Error ? e : error('The designs could not be saved.');
    } finally {
      if (db) db.close();
      saving = false;
    }
  }

  window.VPProductCart = Object.freeze({ read: read, getArtwork: getArtwork, commit: commit, commitBuilderItems: commitBuilderItems, commitReorderItems: commitReorderItems });
}());
